/* tslint:disable:jsx-no-lambda */
import DeepLinkMailView from './DeepLinkMailView';
import { observer } from 'mobx-react';
import App from 'owa-application/lib/components/App';
import Droppable from 'owa-dnd/lib/components/Droppable';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { ImmersiveReaderContainer } from 'owa-immersive-reader';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyResetFocus } from 'owa-mail-focus-manager';
import setTypeOfItemBeingDragged from 'owa-mail-store/lib/actions/setTypeOfItemBeingDragged';
import store from 'owa-mail-store/lib/store/Store';
import { trace } from 'owa-trace';
import * as React from 'react';
import { lazySetupUndoHotKeys } from 'owa-mail-hotkeys';
import { lazyKeydown } from 'owa-hotkeys';

const styles = require('owa-mail-module-view/lib/components/MailModule.scss');

export interface DeepLinkModuleProps {
    subRoute: string;
}
const DRAG_HINT_CHECK_PERIOD_IN_MILLISECONDS = 3000;

@observer
@lazyKeydown(lazySetupUndoHotKeys.importAndExecute)
export default class DeepLinkModule extends React.Component<DeepLinkModuleProps, {}> {
    // Sometimes the browser has a bug which doesn't send the dragLeave event when the drag is over.
    // So we need to repeatedly check whether to remove the drag hint after a certain time
    // before we receive dragLeave/drop event.
    private pendingDragHintRemover;
    private lastDragOverTime;

    componentDidMount() {
        // Set initial focus after component is mounted
        lazyResetFocus.importAndExecute();
        // Override min-width on the global style after mount.
        document.body.style.minWidth = '0';
    }

    render() {
        switch (this.props.subRoute) {
            case 'attachment':
                return <App renderHeader={() => null} />;
            default:
                const emptyDropViewState = createDropViewState();

                return (
                    <App renderHeader={() => null}>
                        <Droppable
                            classNames={styles.mailMain}
                            onDrop={this.onDrop}
                            onDragOver={this.onDragOver}
                            onDragLeave={this.onDragLeave}
                            dropViewState={emptyDropViewState}
                            shouldIgnoreTransientOnDragLeave={true}>
                            <div className={styles.allPaneContainer}>
                                <DeepLinkMailView />
                            </div>
                        </Droppable>
                        {isFeatureEnabled('rp-immersiveReader') && <ImmersiveReaderContainer />}
                    </App>
                );
        }
    }

    private onDragLeave = () => {
        trace.info('onDragLeave');
        setDataItemType(null);
        this.clearPendingDragHintRemover();
    };

    private onDragOver = (dragInfo: DragData) => {
        this.lastDragOverTime = Date.now();
        if (!this.pendingDragHintRemover) {
            this.pendingDragHintRemover = setInterval(() => {
                trace.info('Check last DragOver time');
                // If we haven't received any dragOver event within the period, let's hide the drag hint.
                if (Date.now() - this.lastDragOverTime >= DRAG_HINT_CHECK_PERIOD_IN_MILLISECONDS) {
                    setDataItemType(null);
                    this.clearPendingDragHintRemover();
                }
            }, DRAG_HINT_CHECK_PERIOD_IN_MILLISECONDS);
        }

        setDataItemType(dragInfo.itemType);
    };

    private onDrop = (dragData: any) => {
        setDataItemType(null);
        this.clearPendingDragHintRemover();
    };

    private clearPendingDragHintRemover() {
        trace.info('clearPendingDragHintRemover');
        if (this.pendingDragHintRemover) {
            clearInterval(this.pendingDragHintRemover);
            this.pendingDragHintRemover = null;
        }
    }
}

function setDataItemType(newValue: string) {
    if (store.typeOfItemBeingDragged != newValue) {
        setTypeOfItemBeingDragged(newValue);
    }
}
